import { getStore } from 'core_main/store';
import { importAndInitializePubNub } from 'core_main/helpers/vendors';
import {
  CUSTOMER_TYPING_ENDED,
  CUSTOMER_TYPING,
} from 'core_main/pubnub/constants';
import { SendTypingActivityParameters } from './types';
import { validateSendTypingActivityParams } from './helpers';

export const sendTypingStatusSignal = (
  sessionId: SendTypingActivityParameters['conversationId'],
  typing: SendTypingActivityParameters['typing'],
) => {
  importAndInitializePubNub().then((module) => {
    const pubnub = module;

    const store = getStore();

    const { sessions } = store;

    const session = sessions[sessionId];

    if (!session) return;

    const { channels } = session.attributes.pubnub.data;

    const sharedConversationChannel = channels.find(
      (channel) => channel.type === 'shared-conversation',
    );

    if (!sharedConversationChannel) return;

    const sharedConversationChannelName = sharedConversationChannel.name;

    const signalStatus = typing ? CUSTOMER_TYPING : CUSTOMER_TYPING_ENDED;

    if (typeof pubnub === 'object') {
      pubnub.signal({
        channel: sharedConversationChannelName,
        message: signalStatus,
      });
    }
  });
};

export const sendTypingActivity = (
  parameters: SendTypingActivityParameters,
) => {
  const sessionId = parameters?.conversationId;
  const typing = parameters?.typing;

  try {
    const validateSendTypingStatusParamsError = validateSendTypingActivityParams(
      sessionId,
      typing,
    );

    if (validateSendTypingStatusParamsError) {
      throw validateSendTypingStatusParamsError;
    }

    const store = getStore();

    const { settings } = store;

    const { showTypingIndicatorWeb } = settings;

    if (!showTypingIndicatorWeb) return undefined;

    sendTypingStatusSignal(sessionId, typing);
  } catch (error) {
    console.error('Failed to send typing status', error);
  }

  return undefined;
};
